export default "__VITE_ASSET__mlnDC_XY__"